"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginDefinition_1 = require("../PluginDefinition");
/**
 * Ractive component plugin definition.
 */
class RactiveComponentPluginDefinition extends PluginDefinition_1.default {
    /**
     * @inheritDoc
     */
    constructor(definition) {
        super(definition);
        /**
         * The component template.
         */
        this.template = "";
        /**
         * The component name.
         */
        this.name = "";
        if (definition.elementName) {
            this.name = definition.elementName;
        }
        if (definition.template) {
            this.template = definition.template;
        }
    }
    /**
     * Gets the template.
     */
    getTemplate() {
        return this.template;
    }
    /**
     * Gets the element name.
     */
    getElementName() {
        return this.name;
    }
    /**
     * @inheritDoc
     */
    static getType() {
        return "ractive_component";
    }
}
exports.default = RactiveComponentPluginDefinition;
